import { Injectable } from '@angular/core';
import { BaseService } from '../../../../../core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InvoiceStrategyService extends BaseService{
  private url = 'api/invoice-strategy';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  getByCode(data): Observable<any[]> {
    const url = `${this.getUrl()}/get-by-code?supstaCode=`+data;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`getAll`)),
      catchError(this.handleError<any>(`getAll`))
    );
  }
}
